// src/components/RuleTypeDropdown.js
import React from 'react';
import PropTypes from 'prop-types';
import styles from './RuleTypeDropdown.module.css';

const RuleTypeDropdown = ({ value, onChange }) => {
  return (
    <div className={styles.dropdownContainer}>
      <label htmlFor="ruleType">Rule Type</label>
      <select id="ruleType" name="ruleType" value={value} onChange={onChange}>
        <option value="Keepers">Keepers</option>
        <option value="Prizes">Prizes</option>
      </select>
    </div>
  );
};

RuleTypeDropdown.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RuleTypeDropdown;
